<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Seat</h2>
        <h3></h3>

        <div class="upper-content-wrapper">
          <photo-grid-alt :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="pedopul-seat1@1x.jpg"
              src2="pedopul-seat1@2x.jpg"
              alt="Photo of Ped-o-Pul seat"
            />
          </photo-grid-alt>

          <cta-prod-button
            class="cta-button wide"
            link="ped-o-pul"
            src="contrology-ped2@1x.jpg"
            src2="contrology-ped2@2x.jpg"
            alt="Close-up photo of Contrology Ped-o-Pul thumbnail"
            productName="KSG/CT Ped-o-Pul"
            productSub='All models'
          />

          <div class="content-wrapper">
            <section class="intro">
              <h2>Seat</h2>
              <h3></h3>
              <p>
                Custom designed and fabricated, the Ped-o-Pul bike seat features a stainless steel adjustable attachment system and premium upholstered saddle.  Attributed in use to Karla Trier, the Ped-o-Pul “bike seat” adjusts to 3 positions (brown upholstery as shown only). The seat can be rotated out of the way during standing exercise.
              </p>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
              additionalText="12 week lead time."
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited Lifetime Warranty</icon-link>
              <icon-link
                url="support#returns"
                img="icon-guarantee.svg"
                alt="Guarantee icon"
                title="Learn more"
              >30-Day Money Back Guarantee</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Upholstery: Brown only</icon-link>
            </section>

            <cta-prod-button
              class="cta-button"
              link="ped-o-pul"
              src="contrology-ped2@1x.jpg"
              src2="contrology-ped2@2x.jpg"
              alt="Close-up photo of Contrology Ped-o-Pul thumbnail"
              productName="KSG/CT Ped-o-Pul"
              productSub='All models'
            />

            <section class="more">
              <tertiary-button text="More Ped-o-Pul Accessories" url="/accessories/Ped-o-Pul" />
            </section>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGridAlt from "@/components/PhotoGridAlt.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import CtaProdButton from "@/components/CtaProdButton.vue";
import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "seat",

  metaInfo: {
    title: "Pilates Ped o Pul Seat - Pilates Pedi Pole Seat - Ped O Pull Seat",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Want a seat for your Pilates Ped o Pull? This custom designed & fabricated bike seat adjusts to 3 positions & rotates out of the way for standing exercises. Shop now."
      }
    ]
  },

  components: {
    PhotoGridAlt,
    Photo,
    ProductSelector,
    IconLink,
    CtaProdButton,
    TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      product: {
        label: "Select a Seat",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 42131969966273,
          partnumber: 16915,
          price: 350,
          name: "Seat",
          available: true
        }
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
